import type { AnyAbility } from '@casl/ability';

/**
 * Returns true if the user has at least one unconditional, non-inverted
 * review or approve rule — the minimum required to access the Approval Center.
 *
 * Mirrors the inline check in UISidebar.tsx and the PM requirement:
 * "only users with request-approval (review) or approve rights can see the Approval Center."
 */
export function canAccessApprovalCenter(ability: AnyAbility): boolean {
   return ability.rules.some(
      ({ subject, action, inverted, conditions }) =>
         !!subject && !inverted && !conditions && [action].flat().some((a) => ['approve', 'review', 'manage'].includes(a)),
   );
}
